import QuoteSlider from './src/QuoteSlider';

QuoteSlider.defineElement();
